import { getUseWrappedQueryWithAxiosConfig } from './getUseWrappedQueryWithAxiosConfig';
export const getUseWrappedQuery = ({ request, wrapperOptions, getAutofill, getUseQuery, }) => {
    const useWrappedQuery = (params, queryOptions) => {
        return getUseWrappedQueryWithAxiosConfig({
            request,
            wrapperOptions,
            getAutofill,
            getUseQuery,
        })(params, {}, queryOptions);
    };
    return useWrappedQuery;
};
